import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DialogPopup } from "../../../components/DialogPopup";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import { BtnGroupStyle, BtnIconStyle, DataGridListStyle } from "../../../Theme";
import { v4 as uuid } from "uuid";
import { YSButton } from "../../../uikit/YSButton";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { RemoveRxAlertById, RxAlertPrint } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import NoRecords from "../../../components/NoRecords";
import { useNavigate } from "react-router";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { PrintClick, TextClick } from "../../../components/Content";
import { loadingRxAlertsDetails } from "../../../Redux/Slice/RxAlertsDetailsSlice";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { REPORT_BASE_URL } from "../../../Apis/Constants";
import { Tooltip } from "@mui/material";

export default function RxAlertsDetails(props: any) {
  const { docId, docName, setShowFlow } = props;
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(50);
  const [selectionData, setSelectionData] = useState("");
  const navigate = useNavigate();
  const [deletePharmacyPopup, setDeletePharmacyPopup] = useState(false);

  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };

  const [printPopup, setPrintPopup] = useState(false);
  const handleShowPrintPopupClick = () => {
    setPrintPopup(true);
  };
  const handleHidePrintPopupClick = () => {
    setPrintPopup(false);
    GetRxAlertsList(page);
    dispatch(loadingTopRibbon());
  };
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      const doctorId: any = localStorage.getItem("doctorId");
      params.append("doctorId", doctorId);
      params.append("rxAlertId", selectionData);
      const result = await RemoveRxAlertById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        GetRxAlertsList(page);
        dispatch(loadingTopRibbon());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const columns: GridColDef[] = [
    {
      field: "patientName",
      headerName: "Patient Name",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => (
        <TextClick
          onClick={() =>
            navigate("/rxalertsreview", {
              state: { rowData: row },
            })
          }
          Text={`${row?.patientFirstName} ${row?.patientLastName}`}
        />
      ),
    },
    {
      field: "drugDescription",
      headerName: "Drug Description",
      width: 250,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "alertDescription",
      headerName: "Alert Description",
      width: 180,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "alertDate",
      headerName: "Alert Date",
      width: 100,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 90,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => (
        <PrintClick
          onClick={() => {
            handleShowPrintPopupClick();
            rxAlertActionPrint(row);
          }}
        />
      ),
    },
  ];
  const RxAlertsListState = useSelector((state: any) => {
    return { ...state.RxAlertsDetailsSlice };
  }); //redux data

  const [rowCountState, setRowCountState] = useState(
    RxAlertsListState?.Pagination?.totalItems || 0
  );

  const GetRxAlertsList = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      selectedDoctorId: docId,
      pageSize: pageSize,
    };
    dispatch(loadingRxAlertsDetails(paramsData));
  };

  useEffect(() => {
    GetRxAlertsList(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      RxAlertsListState?.Pagination?.totalItems !== undefined
        ? RxAlertsListState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [RxAlertsListState?.Pagination?.totalItems, setRowCountState]);
  const MainDoctor = localStorage.getItem("DoctorName");

  const [loader, setLoader] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const doctorId: any = localStorage.getItem("doctorId");

  const rxAlertActionPrint = async (props: any) => {
    try {
      setLoader(true);
      const bodyData = {
        messageId: props?.messageId,
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: doctorId,
          onBehalfDoctorId: docId,
          selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
        },
      };
      const result = await RxAlertPrint(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportUrl);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (eor) {
      setLoader(false);
    }
  };

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        textAlign={{ xs: "center", md: "right", lg: "right" }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            columnGap: 30,
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              columnGap: 5,
            }}
          >
            {" "}
            <Typography component="span" color="primary" variant="body2">
              Provider
            </Typography>{" "}
            <Typography component="span" variant="body2">
              {docName === "My Own Prescriptions"
                ? MainDoctor?.toUpperCase()
                : docName?.toUpperCase()}
            </Typography>{" "}
          </Box>{" "}
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              columnGap: 5,
            }}
          >
            <Typography component="span" variant="body2">
              Selected ({selectionData.length})
            </Typography>

            <BtnIconStyle>
              <Tooltip title="Delete">
                <IconButton
                  type="button"
                  className="trash"
                  onClick={handleShowDeletePopupClick}
                >
                  <img src={TrashIcon} alt="Delete" loading="lazy" />
                </IconButton>
              </Tooltip>
            </BtnIconStyle>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} marginBottom={1}>
        <DataGridListStyle>
          <DataGrid
            rows={RxAlertsListState?.Items ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            columns={columns}
            autoHeight
            rowHeight={40}
            pageSize={pageSize}
            disableSelectionOnClick
            checkboxSelection
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            paginationMode="server"
            getRowId={(row) => row.rxAlertId ?? uuid()}
            loading={RxAlertsListState.isLoading}
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            error={RxAlertsListState?.error || undefined}
            rowCount={rowCountState}
            page={page}
            rowsPerPageOptions={[pageSize]}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onSelectionModelChange={(ids: any) => {
              setSelectionData(ids);
            }}
          />
        </DataGridListStyle>
      </Grid>
      <Grid item xs={12} my={2}>
        <BtnGroupStyle className="middle">
          <YSButton
            className=""
            children={"Back"}
            variant={"outlined"}
            size={"large"}
            onClick={() => {
              setShowFlow(false);
            }}
          />{" "}
        </BtnGroupStyle>
      </Grid>{" "}
      <DialogPopup
        windowsize={"md"}
        show={printPopup}
        handleShowPopupClick={handleShowPrintPopupClick}
        handleHidePopupClick={handleHidePrintPopupClick}
        close={true}
      >
        {loader ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              textAlign="center"
              marginTop={2}
              className="btns"
            >
              <iframe
                src={REPORT_BASE_URL + reportUrl}
                height="450px"
                width="850px"
                title="PrintReport"
              />
            </Grid>
          </Grid>
        )}
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
